interface SectionHeaderProps {
  title: string;
  className?: string;
}

export function SectionHeader({ title, className }: SectionHeaderProps) {
  return (
    <div
      className={`border-surface-dark mb-14 flex w-full flex-row border-r-2 border-l-2 sm:border-r-3 sm:border-l-3 ${className}`}
    >
      <h1 className="font-impact text-nav-dark w-full truncate px-5 text-center text-2xl leading-none tracking-wide sm:text-3xl md:text-4xl">
        {title}
      </h1>
    </div>
  );
}
